import React, { useEffect } from "react";
import "../../../styles/adminconsole.css";
import usercreated from "src/assets/images/user-create-icon.svg";
import usersource from "src/assets/images/user-source-icon.svg";
import userspeedboat from "src/assets/images/user-speedboat-icon.svg";
import { useAccountStore } from "../../../hooks/admin/account";
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import Helper from 'src/support/Helper';


const AccountDetailHeader = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ accountDetail }, { get_account_detail }, { }] =
        useAccountStore();

    useEffect(() => {
        async function fetchHere() {
            __set("ACCOUNT_DETAIL_API_CALL");
            await get_account_detail(props.accountDetails);
            setTimeout(() => {
                __remove("ACCOUNT_DETAIL_API_CALL");
            }, 2000);
        }
        fetchHere();
    }, []);
    return (
        <>
            {!__check(["ACCOUNT_DETAIL_API_CALL"]).status && (
                <div className="accountdetails bg-gray3">
                    <div className="acsearchuser">
                        <div className="accordion-item ">
                            <h2 className="accordion-header" id="searchInput">
                                <button
                                    className="accordion-button px-3"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#collapseSearch"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                </button>
                            </h2>
                            <div className="accordion-collapse collapse in" id="collapseSearch"
                                aria-labelledby="searchInput"
                                data-parent="#accordionExample">
                                <div className="accordion-body pt-0">
                                    <div className="user-details-top container">
                                        <div className="user-details-tleft">
                                            <div className="user-details-name  mb-3">
                                                <h4 className="font-18 font-arial mt-0">
                                                    <strong> {accountDetail.account_name}</strong>
                                                </h4>
                                                <span>Account# {accountDetail.account_number}</span>
                                            </div>

                                            <p className="text-black-stone">
                                                <span>
                                                    Updated on:{" "}
                                                    {accountDetail.updatedDate && Helper.getDatepickerFormatAdminConsole(accountDetail.updatedDate)}

                                                </span>
                                                <span className="px-1"> | </span>{" "}
                                                <span className="pe-2">
                                                    Status: {accountDetail.active ? "Active" : "Inactive"}{" "}
                                                </span>

                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-details-bottom account-details-bottom">
                                    <ul>
                                        <li>
                                            <div className="container">
                                                <div className="account-details-bottom-left d-flex align-items-center">

                                                    <span className="d-flex align-items-center">
                                                        <i className="lh-base">
                                                            <img src={usercreated} className="me-2" />
                                                        </i>
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Created on: {accountDetail.createdDate && Helper.getDatepickerFormatAdminConsole(accountDetail.createdDate)}
                                                        </p>{" "}
                                                    </span>

                                                    <span className="d-flex align-items-center">
                                                        <i className="lh-base">
                                                            <img src={userspeedboat} className="me-2" />
                                                        </i>
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Speedboat: {accountDetail.speedboat === 'S' ? 'Silica' : accountDetail.speedboat === 'B' ? 'EBV' : 'Abacus'}
                                                        </p>{" "}
                                                    </span>
                                                    <span className="d-flex align-items-center">
                                                        <i className="lh-base">
                                                            <img src={usersource} className="me-2" />
                                                        </i>
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Sales Org: {accountDetail.sales_org}
                                                        </p>
                                                    </span>

                                                </div>
                                                <div className="text-black-stone account-details-bottom-right">
                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Currency: {accountDetail.currency}
                                                        </p>{" "}
                                                        <div className="px-4">| </div>
                                                    </span>
                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Payment: {accountDetail.payment_term_id}
                                                        </p>{" "}
                                                        <div className="px-4">| </div>
                                                    </span>
                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            Bill to Country: {accountDetail.bill_to_country_code}
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="container">
                                                <div className="text-black-stone account-details-bottom-left">
                                                    <p className="mb-0 text-black-stone">
                                                        {" "}
                                                        Description: {accountDetail.description}
                                                    </p>
                                                </div>
                                                <div className="text-black-stone account-details-bottom-right">

                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                            SDI: {accountDetail.sdi_number}
                                                        </p>{" "}
                                                        <div className="px-4">| </div>
                                                    </span>

                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                          Credit Risk: {accountDetail.creditRisk === true ? 'Yes' : accountDetail.creditRisk === false ? 'No' : ''}
                                                        </p>{" "}
                                                      <div className="px-4">| </div>
                                                    </span>

                                                    <span className="d-flex align-items-center justify-content-between">
                                                        <p className="mb-0 text-black-stone">
                                                            {" "}
                                                          Order Block: {accountDetail.orderBlock === true ? 'Yes' : accountDetail.orderBlock === false ? 'No' : ''}
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AccountDetailHeader;
